export const ADD_ORDER_COMMENT = 'ADD_ORDER_COMMENT';
export const ADD_ORDER_COMMENT_SUCCESS = 'ADD_ORDER_COMMENT_SUCCESS';
export const ADD_ORDER_COMMENT_ERROR = 'ADD_ORDER_COMMENT_ERROR';

export const AddOrderComment = (data) => ({
  type: ADD_ORDER_COMMENT,
  payload: data,
});
